const CONFIGURACION_INTEGRACIONES_HARDCODED_YPF = { puedeCancelarTerminalesTarjetasEnCurso: true };

const getConfiguracionIntegraciones = async () => {
  return CONFIGURACION_INTEGRACIONES_HARDCODED_YPF;
};

const configuracionIntegraciones = {
  getConfiguracionIntegraciones,
};

export default configuracionIntegraciones;
